
import '../App.css';
import React, { useState, useEffect, useRef } from 'react';
import logo from '../logo.png'
import { useLocation, useNavigate } from 'react-router-dom';
import { db } from '../config';

import "@fontsource/open-sans"; // Defaults to weight 400
import "@fontsource/open-sans/400.css"; // Specify weight
import "@fontsource/open-sans/400-italic.css"; // Specify weight and style
import moment from 'moment/moment';
import { FaUserFriends } from "react-icons/fa";
import { FaUserTie } from "react-icons/fa";
import ReactModal from 'react-modal';
import { toast } from 'wc-toast'
import Select, { components } from 'react-select';
import { add_icon, delete_icon } from '../assets/Icons';
import { IoIosCloseCircle } from "react-icons/io";
import { MdOutlineFeed } from "react-icons/md";
import { decrypt, encrypt } from '../Crypto';
import { connect } from 'react-redux';
import { SetDevice, SetId } from './redux/actions';
import BackDrop from './Backdrop';
import { VscThreeBars } from "react-icons/vsc";
//import './SlideDrawer.css'
import { Collapse } from "react-collapse";
import { FiImage, FiClock, FiSettings } from "react-icons/fi";
//import { ToastContainer, toast } from 'react-toastify';
//import 'react-toastify/dist/ReactToastify.css';

const userdb = db.ref('userdb');

const devices_db = db.ref('devices');
const customerdb = db.ref('customerdb');

const height = window.innerHeight;
const width = window.innerWidth;

const room = db.ref('Sign_up')

const DATA = [
  {
    id: 'bd7acbea-c1b1-46c2-aed5-3ad53abb28ba',
    title: 'Dancer',
    uri: 'https://randomuser.me/api/portraits/men/32.jpg',
    name: 'Pablo '
  },
  {
    id: '3ac68afc-c605-48d3-a4f8-fbd91aa97f63',
    title: 'Dancer ',
    uri: 'https://randomuser.me/api/portraits/men/79.jpg',
    name: 'Rodriguez '
  },
  {
    id: '58694a0f-3da1-41f-bd96-145571e29d72',
    title: 'Dancer ',
    uri: 'https://randomuser.me/api/portraits/men/31.jpg',
    name: 'Maxi milianos '
  },
  {
    id: '58694a0f-3da1-471f-bd96-145571e29d7',
    title: 'Dancer ',
    uri: 'https://randomuser.me/api/portraits/men/30.jpg',
    name: 'Leo'
  },
  {
    id: '58694a0f-3da1-471f-bd96-145571e29d2',
    title: 'Dancer ',
    uri: 'https://randomuser.me/api/portraits/men/42.jpg',
    name: 'Golin'
  },
  {
    id: '58694a0f-3da1-471f-bd96-145571e29d7',
    title: 'Dancer ',
    uri: 'https://randomuser.me/api/portraits/men/70.jpg',
    name: 'Leo'
  },
  {
    id: '58694a0f-3da1-471f-bd96-145571e29d2',
    title: 'Dancer ',
    uri: 'https://randomuser.me/api/portraits/men/42.jpg',
    name: 'Golin'
  },
  {
    id: '58694a0f-3da1-471f-bd96-145571e29d7',
    title: 'Dancer ',
    uri: 'https://randomuser.me/api/portraits/men/30.jpg',
    name: 'Leo'
  },
  {
    id: '58694a0f-3da1-471f-bd96-145571e29d2',
    title: 'Dancer ',
    uri: 'https://randomuser.me/api/portraits/men/52.jpg',
    name: 'Golin'
  }
];


function Devices({ items, SetId, SetDevice }) {

  console.log('Show welcome ...', items.show_welcome)

  const [aiOpen, setAiOpen] = useState(false);

  const AiSubItem = ({ icon, label, onClick }) => (
    <div
      onClick={onClick}
      style={{
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        gap: 14,
        height: 52,
        paddingLeft: 18,
        paddingRight: 20,
        marginBottom: 8,
        borderRadius: 12,
        backgroundColor: "transparent",
      }}
    >
      <div
        style={{
          width: 22,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#9AA4B2",
        }}
      >
        {icon}
      </div>

      <span
        style={{
          fontSize: label === "Create Images" ? 13 : 15,
          fontWeight: 600,
          lineHeight: "1",
          color: "#9AA4B2",
          textAlign: "left",
          whiteSpace: "nowrap",
        }}
      >
        {label}
      </span>
    </div>
  );

  const AiLeftSubMenuDesktop = () => {
    return (
      <div
        style={{
          display: "flex",
          width: width * 0.14,
          //  alignSelf: "center",
          marginTop: 8,
          // justifyContent: "center", // center whole block
          marginLeft: 52,
        }}
      >
        {/* inner aligned block */}

        {/* vertical line */}
        <div
          style={{
            width: 4,
            backgroundColor: "#2E3642",
            borderRadius: 4,
            marginRight: 14,
          }}
        />

        {/* menu items */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start", // text stays left aligned
          }}
        >
          <AiSubItem
            icon={<FiImage />}
            label="Create Images"
            onClick={() => {
              if (items.devices > 0) {
                navigate("/AICreate")
                // Do something if devices are available
              }
              else toast('Add a Boom Display Device before using Ai')
            }}
          />

          <AiSubItem
            icon={<FiClock />}
            label="History"
            onClick={() => navigate("/AIGenerator")}
          />

          <AiSubItem
            icon={<FiSettings />}
            label="Settings"
            onClick={() => navigate("/AISetting")}
          />
        </div>


      </div>
    );
  };


  const AiLeftSubMenuMobile = () => {
    return (
      <div
        style={{
          display: "flex",
          width: width * 0.35,
          alignSelf: "center",
          marginTop: 8,
        }}
      >
        {/* vertical line */}
        <div
          style={{
            width: 4,
            backgroundColor: "#2E3642",
            borderRadius: 4,
            marginRight: 14,
            marginLeft: 12,
          }}
        />

        <div style={{ flex: 1 }}>
          <AiSubItem
            icon={<FiImage />}
            label="Create Images"
            onClick={() => navigate("/AICreate")}
          />

          <AiSubItem
            icon={<FiClock />}
            label="History"
            onClick={() => navigate("/AIGenerator")}
          />

          <AiSubItem
            icon={<FiSettings />}
            label="Settings"
            onClick={() => navigate("/AISetting")}
          />
        </div>
      </div>
    );
  };


  console.log('Items ', items)

  useEffect(() => {
    if (items.myid == null) {
      let obj = localStorage.getItem('display')
      if (obj != null) { obj = JSON.parse(obj); SetId(obj) }
      else { navigate('/') }
    }
  }, [items])

  function lastActive(dat) {
    let diff = moment(new Date()).diff(new Date(Number(dat)), 'minutes')
    diff = Math.abs(diff)

    // less than 5 minutes 

    if (diff <= 5) {
      return 'Online'
    }

    // less than 1 hour 

    else if (diff <= 60) {
      return 'Active 5 mins Ago'
    }

    // calculation in hour 

    else if (diff <= 1440) {
      return `${Math.trunc((diff / 60))} hours ago`
    }


    // calculation in day 
    else if (diff > 1440) {
      return `${Math.trunc(diff / (1440))} days ago`
    }

  }

  // green , #008550
  // yellow , #EFB700
  // red , #B71D13

  function lastActiveColor(dat) {
    let diff = moment(new Date()).diff(new Date(Number(dat)), 'minutes')
    diff = Math.abs(diff)

    // less than 5 minutes 

    if (diff <= 5) {
      return '#008550'
    }

    // less than 1 hour 

    else if (diff <= 60) {
      return '#EFB700'
    }

    // calculation in hour 

    else if (diff <= 1440) {
      return `#B71D13`
    }


    // calculation in day 
    else if (diff > 1440) {
      return `#B71D13`
    }

  }


  // const {state} = useLocation();
  // const user_id = state.item
  // console.log ('ID',user_id) 

  const key = items.myid == null ? null : items.myid.id


  // console.log('Key ', key)

  async function addFeedback() {
    const room = db.ref('Sign_up')
    if (name != '') {
      let obj = {
        ID: new Date().getTime(),
        feedback: encrypt(name)
      }
      await room.child(String(key)).child('feedback').child(String(obj.ID)).set(obj)
      setAdd_feed(false);
      setName('')
      toast('Feedback is submitted')
    }
    else toast('Please write something')
  }

  let curr = new Date().getTime();

  const navigate = useNavigate();

  const [devices, setDevices] = useState([])

  const state = useLocation()

  useEffect(() => {
    if (state.state != undefined) {
      if (state.state.add != undefined) {
        setAdd(true)
      }
    }
  }, [state])

  console.log('State ', state)


  useEffect(() => {
    if (key != null) {
      const subscribe = userdb.child(String(key)).child('devices').on('value', (snapshot) => {
        if (snapshot != null && snapshot.val() != null) {
          let arr = Object.values(snapshot.val());
          let temp = [];
          for (let i = 0; i < arr.length; i++) {
            if (arr[i].name != undefined) temp.push(arr[i])
          }
          SetDevice(temp.length)
          setDevices([...temp])
        }
        else if (snapshot != undefined) {
          SetDevice(0)
          setDevices([])
        }
      })
      return () => subscribe()
    }
  }, [key])


  const [touched1, setTouched1] = useState(false);

  function toggleTouched1() {
    setTouched1(!touched1);
  }

  function handleMouseUp1() {
    // Handle smooth animation when clicking without holding
    setTimeout(() => {
      setTouched1(!touched1);
    }, 150);
  }

  const [add, setAdd] = useState(false)
  const [id, setId] = useState('')
  const [id2, setId2] = useState('')
  const [id3, setId3] = useState('')

  const ref1 = useRef()
  const ref2 = useRef()
  const ref3 = useRef()

  const [name, setName] = useState('')

  const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

  const [success, setSuccess] = useState(false)

  // ================= MAILCHIMP SYNC =================
  const SERVER_BASE_URL = "https://us-central1-boomdisplays-3e87d.cloudfunctions.net/app";

  async function syncMailchimpPayingClient(userKey) {
    try {
      const snap = await room.child(String(userKey)).once("value");
      const user = snap.val();

      if (!user?.Email) {
        console.log("Mailchimp paying client sync skipped: email not found");
        return false;
      }

      const response = await fetch(`${SERVER_BASE_URL}/mailchimp/paying-client`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: user.Email,
          firstName: user.FirstName || "",
          lastName: user.LastName || "",
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        console.log("Mailchimp paying client sync failed:", data);
        return false;
      }

      console.log("Mailchimp paying client synced:", data);
      return true;
    } catch (error) {
      console.log("Mailchimp paying client sync error:", error);
      return false;
    }
  }

  async function add_device() {
    if (name != '' && id != '' && id2 != '' && id3 != '') {
      let obj = {
        device: id + id2 + id3,
        name: encrypt(name),
        last: new Date().getTime()
      }
      console.log('My id ', obj.device)
      let snap = await userdb.child(String(key)).child('devices').orderByChild('name').equalTo(encrypt(name)).once('value')
      if (snap.val() == null) {

        let snapshot = await devices_db.child(String(obj.device)).once('value')

        if (snapshot.val() == null) {
          toast('Such ID doesnot exist')
        }

        else {
          if (snapshot.val().parent != undefined) {

            if (snapshot.val().parent == key) toast('It is already in your device list')
            else toast('It is already connected to other device !')
          }

          else {
            let curr = new Date().getTime()
            let creat = Number(snapshot.val().time)
            let diff = moment(new Date(curr)).diff(new Date(creat), 'minutes')
            console.log('Diff ', curr, diff, moment(new Date(curr)).diff(new Date(creat), 'hours'), moment(new Date(curr)).diff(new Date(creat), 'days'))

            if (diff <= 5) {
              let new_length = devices.length + 1;
              const room = db.ref('Sign_up')
              await room.child(String(key)).child(String('device_no')).set(new_length)

              await devices_db.child(String(obj.device)).child('parent').set(String(key))
              await userdb.child(String(key)).child('devices').child(String(obj.device)).set(obj)

              await syncMailchimpPayingClient(key);

              setSuccess(true)
              setId('')
              setId2('')
              setId3('')
              setName('')
              toast('Device is added')

            }
          }
        }

      }
      else {
        toast('This name already exist . Try another one ')
      }
    }
    else toast('Fill up fields properly')
  }

  const [delete_content, setDeleteContent] = useState(false)

  async function delete_calendar(code) {
    const calendardb = db.ref('calendardb');
    console.log('Delete code ', code)
    let val = await calendardb.child(String(key)).orderByChild('device/ID').equalTo(String(code)).once('value')
    if (val.val() != null) {
      console.log('All val    ', val.val())
      let arr = Object.values(val.val())
      for (let i = 0; i < arr.length; i++) {
        await calendardb.child(String(key)).child(String(arr[i].ID)).remove()
      }
    }
  }

  async function delet_content() {
    await devices_db.child(String(delete_content.device)).remove()
    let new_length = devices.length - 1;
    const room = db.ref('Sign_up')
    await room.child(String(key)).child(String('device_no')).set(new_length)
    await userdb.child(String(key)).child('devices').child(String(delete_content.device)).remove()
    toast('Content is deleted !')

    let delet_content_curr = delete_content
    setDeleteContent(false)
    await delete_calendar(delet_content_curr.device)
  }

  function dat(str) {
    return new Date(str).getDate() + " " + months[new Date(str).getMonth()] + " " + new Date().getFullYear()
  }

  function mytim(str) {
    return moment(new Date(str)).format('hh:mm a').toString()
  }

  useEffect(() => {
    if (id.length == 3) ref2.current?.focus()
  }, [id])

  useEffect(() => {
    if (id2.length == 3) ref3.current?.focus()
  }, [id2])

  useEffect(() => {
    if (id3.length == 3) ref1.current?.focus()
  }, [id3])


  // For Feedback

  const [add_feed, setAdd_feed] = useState(false)

  const [time, setTime] = useState(Date.now())

  useEffect(() => {
    const interval = setInterval(() => setTime(Date.now()), 1000 * 120)
    return () => {
      clearInterval(interval)
    }
  }, [])


  const [width, setwidth] = useState(window.innerWidth);
  const [height, setWindowHeight] = useState(window.innerHeight);

  useEffect(() => {
    const windowSizeHandler = () => {
      setwidth(window.innerWidth)
      setWindowHeight(window.innerHeight)
    };
    window.addEventListener("resize", windowSizeHandler);

    return () => {
      window.removeEventListener("resize", windowSizeHandler);
    };
  }, []);

  const isMobile = width <= 768;
  const drawerW = isMobile ? width * 0.80 : width * 0.20;

  const [drawerOpen, setDrawerOpen] = useState(false);

  function handleOpenDrawerButton() {
    setDrawerOpen(!drawerOpen);
  }

  function handleBackdropClick() {
    setDrawerOpen(false);
  }


  let drawerClasses = drawerOpen ? "side-drawer open" : "side-drawer";


  // ✅ 3) One-line titles in mobile drawer
  const mobileDrawerTitleStyle = (maxW) => ({
    color: "white",
    marginLeft: 18,
    fontWeight: "600",
    fontSize: 15,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: maxW,
    display: "block",
  });


  return (
    !isMobile ? <div style={{ backgroundColor: '#080A0C', display: 'flex', flexDirection: 'row', width: width, height: height, position: 'absolute', top: 0, left: 0 }}>


      <div style={{ backgroundColor: '#080A0C', position: 'absolute', top: 0, left: 0, display: 'flex', flexDirection: 'column', height: height, width: width * 0.20, textAlign: 'center' }}>


        <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: "#080A0C", width: width * 0.20, height: 100, justifyContent: 'center', alignItems: 'center' }}>
          <img
            src={logo}
            alt="Logo"
            style={{ width: 113, marginTop: 1, height: 53, alignSelf: 'center' }}
          />

        </div>

        {items.show_welcome ? <div onClick={() => navigate('/Welcome')} style={{ cursor: 'pointer', marginTop: 20, display: 'flex', justifyContent: 'center', alignContent: 'center', width: 0.18 * width, padding: 10, alignSelf: 'center', alignItems: 'center', height: 52, }}>

          <div style={{ width: 0.14 * width, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 52, alignItems: 'center', justifyContent: 'space-between' }}>
            <text style={{ color: 'white', marginLeft: 30, fontWeight: '600', fontSize: 16 }}>Welcome</text>
            <div style={{ height: 41, width: 20 }} />
          </div>
        </div> : null}

        <div style={{ marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: 0.18 * width, padding: 10, alignSelf: 'center', alignItems: 'center', height: 52, }}>
          <div style={{ backgroundColor: '#181E25', width: 0.14 * width, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 52, alignItems: 'center', justifyContent: 'space-between' }}>
            <text style={{ color: 'white', marginLeft: 30, fontWeight: '600', fontSize: 16 }}>Devices</text>
            <img src={require('../assets/right.png')} style={{ height: 41, width: 20 }} />
          </div>

        </div>

        <div onClick={() => navigate('/Content')} style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: 0.18 * width, padding: 10, alignSelf: 'center', alignItems: 'center', height: 52, }}>

          <div style={{ width: 0.14 * width, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 52, alignItems: 'center', justifyContent: 'space-between' }}>
            <text style={{ color: 'white', marginLeft: 30, fontWeight: '600', fontSize: 16 }}>Content</text>
            <div style={{ height: 41, width: 20 }} />
          </div>
        </div>

        <div onClick={() => navigate('/Calendars')} style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: 0.18 * width, padding: 10, alignSelf: 'center', alignItems: 'center', height: 52, }}>
          <div style={{ width: 0.14 * width, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 52, alignItems: 'center', justifyContent: 'space-between' }}>
            <text style={{ color: 'white', marginLeft: 30, fontWeight: '600', fontSize: 16 }}>Calendar</text>
            <div style={{ height: 41, width: 20 }} />
          </div>
        </div>

        <div
          onClick={() => setAiOpen(!aiOpen)}
          style={{
            cursor: "pointer",
            marginTop: 5,
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            width: 0.18 * width,
            padding: 10,
            alignSelf: "center",
            alignItems: "center",
            height: 52,
          }}
        >
          <div
            style={{
              width: 0.14 * width,
              flexDirection: "row",
              display: "flex",
              padding: 10,
              borderRadius: 6,
              height: 52,
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <text style={{ color: "white", marginLeft: 30, fontWeight: "600", fontSize: 16 }}>
              AI Generator
            </text>

            <img
              src={require("../assets/right.png")}
              style={{
                height: 41,
                width: 20,
                transform: aiOpen ? "rotate(90deg)" : "rotate(0deg)",
                transition: "transform 200ms ease",
              }}
            />
          </div>
        </div>

        <Collapse isOpened={aiOpen}>
          <AiLeftSubMenuDesktop />
        </Collapse>


        <div onClick={() => navigate('/Subscription')} style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: 0.18 * width, padding: 10, alignSelf: 'center', alignItems: 'center', height: 52, }}>
          <div style={{ position: 'relative', width: 0.14 * width, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 52, alignItems: 'center', justifyContent: 'space-between' }}>
            <text style={{ color: 'white', marginLeft: 30, fontWeight: '600', fontSize: 16 }}>Subscription</text>
            <div style={{ height: 41, width: 20 }} />
            {items.unlicensed > 0 && <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'absolute', height: 20, width: 20, borderRadius: 12, backgroundColor: 'white', borderWidth: 2, borderStyle: 'solid', borderColor: 'red', top: 5, left: 5 }}>
              <text style={{ color: 'red', fontSize: 13 }}>{items.unlicensed}</text>
            </div>}
            {items.trial > 0 && <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'absolute', height: 20, width: 20, borderRadius: 12, backgroundColor: 'white', borderWidth: 2, borderStyle: 'solid', borderColor: '#F7941D', top: 5, right: 20 }}>
              <text style={{ color: '#F7941D', fontSize: 13 }}>{items.trial}</text>
            </div>}
          </div>
        </div>


        <div onClick={() => navigate('/Settings')} style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: 0.18 * width, padding: 10, alignSelf: 'center', alignItems: 'center', height: 52, }}>

          <div style={{ width: 0.14 * width, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 52, alignItems: 'center', justifyContent: 'space-between' }}>
            <text style={{ color: 'white', marginLeft: 30, fontWeight: '600', fontSize: 16 }}>Settings</text>
            <div style={{ height: 41, width: 20 }} />
          </div>
        </div>

      </div>


      <div style={{ display: 'flex', flexDirection: 'column', marginLeft: width * 0.20, width: width * 0.80, position: 'absolute', top: 0, height: height, backgroundColor: '#181E25', alignItems: 'flex-end' }}>

        <div style={{ display: 'flex', height: 100, width: width * 0.7991, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C' }}>

          <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: (width * 0.74) - 105 }}>
            <text style={{ marginLeft: 0, fontSize: 24, fontWeight: '700', letterSpacing: 1.01, color: 'white', textAlign: 'center' }}>Devices</text>
            <div style={{ marginLeft: 6, marginTop: 4 }}>
              <stripe-buy-button
                buy-button-id="buy_btn_1RO0KHGOVgfDdjwd10oaS68C"
                publishable-key="pk_live_51HFkGVGOVgfDdjwdQowSBANlgyEuCLom3Lm7B4iCGtKFLXGfU9ezPScsLZNape1srePuSJ0S29nxgQsQ8X5Y2ZMV00txCVBJMu"
              >
              </stripe-buy-button>
            </div>
          </div>
          <div onClick={() => {
            navigate('/')
            localStorage.removeItem('display')
            localStorage.removeItem('devices')
            SetId(null)
          }} style={{ cursor: 'pointer', alignSelf: 'center', width: 105, height: 36, borderRadius: 6, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', borderWidth: 1, borderStyle: 'solid', borderColor: '#F7941D' }}>
            <text style={{ color: '#F7941D', fontSize: 14, fontWeight: '600', textAlign: 'center' }}>Log out</text>
          </div>
        </div>



        <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: '#181E25', width: width * 0.80, height: height - 100 }}>


          <div style={{ width: 0.74 * width, height: 65, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', alignSelf: 'center', marginTop: 20, backgroundColor: '#F7941D', borderRadius: 12 }}>


            <div style={{ width: 0.73 * width, height: '', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'center', }}>

              <div style={{ width: 0.17 * width, height: '', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'center' }}>

                <div style={{ cursor: 'pointer', display: 'flex', width: 150, height: 46, justifyContent: 'flex-start', alignItems: 'center' }}>

                  <text style={{ fontWeight: '600', fontSize: 17, color: 'black', marginLeft: 3 }}></text>
                </div>

                <div style={{ cursor: 'pointer', display: 'flex', width: 220, height: 46, justifyContent: 'flex-start', alignItems: 'center' }}>

                  <text style={{ fontWeight: '700', fontSize: 15, color: 'black', marginLeft: 3 }}></text>
                </div>


              </div>

              <div style={{ width: 350, height: '', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'center' }}>

                <div onClick={() => setAdd_feed(true)} style={{ cursor: 'pointer', display: 'flex', width: 170, height: 46, backgroundColor: '#FFFFFF', borderRadius: 10, justifyContent: 'center', alignItems: 'center', flexDirection: 'row' }}>
                  <MdOutlineFeed style={{ fontSize: 22 }} />
                  <text style={{ fontWeight: '600', fontSize: 18, color: 'black', marginLeft: 15 }}>Feedback</text>
                </div>

                <div onClick={() => setAdd(true)} style={{ cursor: 'pointer', display: 'flex', width: 170, height: 46, backgroundColor: '#FFFFFF', borderRadius: 10, justifyContent: 'center', alignItems: 'center', flexDirection: 'row' }}>
                  {add_icon}
                  <text style={{ fontWeight: '600', fontSize: 18, color: 'black', marginLeft: 15 }}>Add Device</text>
                </div>

              </div>

            </div>
          </div>




          <div style={{ width: 0.74 * width, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'center', marginTop: 20 }}>


            <div style={{ display: 'flex', height: 51, width: 0.15 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
              <div style={{ display: 'flex', height: 51, width: 0.12 * width, justifyContent: 'flex-start', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>

                <text style={{ color: 'white', fontSize: 16, fontWeight: '600', textAlign: 'center' }}>Name</text>
              </div>
            </div>


            <div style={{ display: 'flex', height: 51, width: 0.09 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
              <div style={{ display: 'flex', height: 51, width: 0.08 * width, justifyContent: 'flex-start', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>

                <text style={{ color: 'white', fontSize: 16, fontWeight: '600', textAlign: 'center' }}>ID Number</text>
              </div>
            </div>


            <div style={{ display: 'flex', height: 51, width: 0.09 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
              <div style={{ display: 'flex', height: 51, width: 0.08 * width, justifyContent: 'flex-start', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>

                <text style={{ color: 'white', fontSize: 16, fontWeight: '600', textAlign: 'center' }}>App Version</text>
              </div>
            </div>



            <div style={{ display: 'flex', height: 51, width: 0.17 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
              <div style={{ display: 'flex', height: 51, width: 0.16 * width, justifyContent: 'flex-start', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>

                <text style={{ color: 'white', fontSize: 16, fontWeight: '600', textAlign: 'center' }}>Last connected</text>
              </div>
            </div>



            <div style={{ display: 'flex', height: 51, width: 0.13 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
              <div style={{ display: 'flex', height: 51, width: 0.10 * width, justifyContent: 'flex-start', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>

                <text style={{ color: 'white', fontSize: 16, fontWeight: '600', textAlign: 'center' }}>Last Online</text>
              </div>
            </div>




            <div style={{ display: 'flex', height: 51, width: 0.08 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
              <div style={{ display: 'flex', height: 51, width: 0.07 * width, justifyContent: 'flex-start', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>

                <text style={{ color: 'white', fontSize: 16, fontWeight: '600', textAlign: 'center' }}>Delete</text>
              </div>
            </div>
          </div>



          <div style={{ width: 0.74 * width, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', alignSelf: 'center', marginTop: 0, overflowY: 'scroll', maxHeight: 1200, overflowX: 'hidden', }}>
            {devices.map((item, id) => <div style={{ width: 0.74 * width, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'center', marginTop: 10 }}>


              <div style={{ display: 'flex', height: 56, width: 0.15 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                <div style={{ display: 'flex', height: 56, width: 0.12 * width, justifyContent: 'flex-start', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>

                  <text style={{ color: 'white', fontSize: 15, fontWeight: '600', textAlign: 'center' }}>{item.name != undefined ? decrypt(item.name) : null}</text>
                </div>
              </div>


              <div style={{ display: 'flex', height: 56, width: 0.09 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                <div style={{ display: 'flex', height: 56, width: 0.08 * width, justifyContent: 'flex-start', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>

                  <text style={{ color: 'white', fontSize: 15, fontWeight: '600', textAlign: 'center' }}>{item.device}</text>
                </div>
              </div>


              <div style={{ display: 'flex', height: 56, width: 0.09 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                <div style={{ display: 'flex', height: 56, width: 0.08 * width, justifyContent: 'flex-start', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>

                  <text style={{ color: 'white', fontSize: 15, fontWeight: '600', textAlign: 'center' }}>{item.version == undefined ? 'Not Found' : Number(item.version).toFixed(1)}</text>
                </div>
              </div>


              <div style={{ display: 'flex', height: 56, width: 0.17 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>

                <div style={{ display: 'flex', height: 56, width: 0.16 * width, justifyContent: 'flex-start', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>

                  <text style={{ color: 'white', fontSize: 15, fontWeight: '600', textAlign: 'left', alignSelf: 'center' }}>{dat(Number(item.last)) + '; ' + mytim(Number(item.last))}</text>
                </div>
              </div>



              <div style={{ cursor: 'pointer', display: 'flex', height: 56, width: 0.13 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                <div style={{ display: 'flex', height: 56, width: 0.10 * width, justifyContent: 'flex-start', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                  <div style={{ width: 16, height: 16, borderRadius: 10, backgroundColor: lastActiveColor(item.last) }} />
                  <text style={{ color: 'white', fontSize: 15, fontWeight: '600', textAlign: 'left', alignSelf: 'center', marginLeft: 6 }}>{lastActive(Number(item.last))}</text>

                </div>
              </div>






              <div onClick={() => setDeleteContent(item)} style={{ cursor: 'pointer', display: 'flex', height: 56, width: 0.08 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                <div style={{ display: 'flex', height: 56, width: 0.07 * width, justifyContent: 'flex-start', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>

                  <text style={{ color: 'white', fontSize: 15, fontWeight: '600', textAlign: 'center' }}>{delete_icon}</text>
                </div>
              </div>


            </div>)}
          </div>



        </div>

      </div>

      <ReactModal
        style={{ overlay: { backgroundColor: 'transparent', display: 'flex', alignSelf: 'center', justifyContent: 'center', alignContent: 'center', alignItems: 'center', height: height }, content: { display: 'flex', position: 'absolute', top: (height - 600) / 2, left: (width - 500) / 2, display: 'flex', backgroundColor: '#111417', width: 550, alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 400, justifyContent: 'center' } }}
        isOpen={add}
        onRequestClose={() => {
          setAdd(false); setSuccess(false); setId('')
          setId2('')
          setId3('')
          setName('')
        }}
        closeTimeoutMS={100}
        shouldFocusAfterRender={true}
        shouldCloseOnOverlayClick={true}
        shouldCloseOnEsc={true}
        shouldReturnFocusAfterClose={true}
        preventScroll={true}
      >
        <div style={{ display: 'flex', flexDirection: 'column', width: '97%', justifyContent: 'center', alignItems: 'center', alignContent: 'center', backgroundColor: '#111417' }}>
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '85%', alignSelf: 'center' }}>
            <text></text>
            <text style={{ fontWeight: '800', fontSize: 26, color: '#3AB549' }}>{success ? `Added successfully.` : null}</text>
            <IoIosCloseCircle onClick={() => {
              setAdd(false); setSuccess(false); setId('')
              setId2('')
              setId3('')
              setName('')
            }} style={{ cursor: 'pointer', position: 'absolute', top: 15, right: 15 }} color='white' size={40} />
          </div>
          {!success ? <div style={{ display: 'flex', flexDirection: 'column', width: '55%', justifyContent: 'center', alignContent: 'center' }}>
            <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', alignSelf: 'center' }}><text style={{ textAlign: 'center', color: 'white', fontWeight: '600', fontSize: 24, fontFamily: "Open Sans", }}>Add New Device </text></div>
            <text style={{ width: 500, alignSelf: 'center', textAlign: 'left', fontSize: 14, fontWeight: '400', color: 'white', marginTop: 20, fontFamily: "Open Sans", }}>ID Number</text>
            <div style={{ width: 500, alignSelf: 'center', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', display: 'flex' }}>
              <input placeholder='ID' style={{ marginTop: 10, padding: 5, letterSpacing: '1.05px', borderRadius: '6px', width: 150, backgroundColor: '#ECFEFD', outline: 'none', height: 35, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: 'black', fontSize: 20, textAlign: 'center', fontFamily: "Open Sans" }} type="text" value={id} onChange={(e) => setId(e.target.value)} />
              <input ref={ref2} placeholder='ID' style={{ marginTop: 10, padding: 5, letterSpacing: '1.05px', borderRadius: '6px', width: 150, backgroundColor: '#ECFEFD', outline: 'none', height: 35, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: 'black', fontSize: 20, textAlign: 'center', fontFamily: "Open Sans", }} type="text" value={id2} onChange={(e) => setId2(e.target.value)} />
              <input ref={ref3} placeholder='ID' style={{ marginTop: 10, padding: 5, letterSpacing: '1.05px', borderRadius: '6px', width: 150, backgroundColor: '#ECFEFD', outline: 'none', height: 35, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: 'black', fontSize: 20, textAlign: 'center', fontFamily: "Open Sans", }} type="text" value={id3} onChange={(e) => setId3(e.target.value)} />

            </div>
            <text style={{ width: 500, alignSelf: 'center', textAlign: 'left', fontSize: 14, fontWeight: '400', color: 'white', marginTop: 20, fontFamily: "Open Sans", }}>Name</text>
            <input ref={ref1} placeholder='Name' style={{ marginTop: 10, padding: 5, letterSpacing: '1.05px', borderRadius: '6px', width: 480, backgroundColor: '#ECFEFD', outline: 'none', height: 35, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: 'black', fontSize: 17, fontFamily: "Open Sans", paddingLeft: 10 }} type="text" value={name} onChange={(e) => setName(e.target.value)} />


            <div onMouseDown={() => toggleTouched1()} onMouseUp={() => handleMouseUp1()} onClick={() => add_device()} style={{ height: 40, padding: 5, alignSelf: 'center', opacity: touched1 ? 0.3 : 1, transition: 'opacity 300ms ease', borderRadius: 5, outline: 'none', marginTop: 30, width: 485, backgroundColor: '#F7941D', display: 'flex', justifyContent: 'center', cursor: 'pointer', alignItems: 'center', borderWidth: 1, borderColor: '#26B8AD' }}> <text style={{ color: 'black', fontWeight: 'bold', fontSize: 22, fontFamily: "Open Sans", }}>Submit</text> </div>
          </div> : <img src={require('../assets/successfull.png')} style={{ width: 300, alignSelf: 'center', height: 300 }} />}
        </div>
      </ReactModal>



      {delete_content != false ? <ReactModal
        style={{ overlay: { backgroundColor: 'transparent', display: 'flex', alignSelf: 'center', justifyContent: 'center', alignContent: 'center', alignItems: 'center', height: height }, content: { display: 'flex', position: 'absolute', top: (height - 530) / 2, left: (width - 500) / 2, display: 'flex', backgroundColor: '#111417', width: 500, alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 260, justifyContent: 'center' } }}
        isOpen={delete_content}
        onRequestClose={() => { setDeleteContent(false) }}
        closeTimeoutMS={100}
        shouldFocusAfterRender={true}
        shouldCloseOnOverlayClick={true}
        shouldCloseOnEsc={true}
        shouldReturnFocusAfterClose={true}
        preventScroll={true}
      >
        <div style={{ display: 'flex', flexDirection: 'column', width: 300, justifyContent: 'center', alignItems: 'center', alignContent: 'center', backgroundColor: '#111417' }}>

          <IoIosCloseCircle onClick={() => setDeleteContent(false)} style={{ cursor: 'pointer', position: 'absolute', top: 15, right: 15 }} color='white' size={40} />

          <div style={{ display: 'flex', flexDirection: 'column', width: '75%', justifyContent: 'center', alignContent: 'center', marginTop: 0 }}>
            <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', alignSelf: 'center', cursor: 'pointer' }}><text style={{ textAlign: 'center', color: 'white', fontWeight: '600', fontSize: 20 }}>{`Are you sure to delete ${decrypt(delete_content.name)} device ?`}</text></div>

            <div style={{ display: 'flex', alignSelf: 'center', flexDirection: 'row', alignItems: 'center', width: 400, justifyContent: 'space-around', marginTop: 40, cursor: 'pointer' }}>
              <div onMouseDown={() => toggleTouched1()} onMouseUp={() => handleMouseUp1()} onClick={() => delet_content()} style={{ height: 40, padding: 5, alignSelf: 'center', opacity: touched1 ? 0.3 : 1, transition: 'opacity 300ms ease', borderRadius: '5px', outline: 'none', width: 130, backgroundColor: '#3AB549', display: 'flex', justifyContent: 'center', cursor: 'pointer', alignItems: 'center' }}> <text style={{ color: 'black', fontWeight: 'bold', fontSize: 17 }}>Yes</text> </div>
              <div onClick={() => setDeleteContent(false)} style={{ height: 40, width: 130, backgroundColor: 'red', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: 5, padding: 5 }}>
                <text style={{ fontWeight: '600', fontSize: 15, color: 'white' }}>No</text>
              </div>
            </div>
          </div>
        </div>
      </ReactModal> : null}



      <ReactModal
        style={{ overlay: { backgroundColor: 'transparent', display: 'flex', alignSelf: 'center', justifyContent: 'center', alignContent: 'center', alignItems: 'center', height: height }, content: { display: 'flex', position: 'absolute', top: (height - 600) / 2, left: (width - 550) / 2, display: 'flex', backgroundColor: '#111417', width: 550, alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 400, justifyContent: 'flex-start' } }}
        isOpen={add_feed}
        onRequestClose={() => {
          setAdd_feed(false);
        }}
        closeTimeoutMS={100}
        shouldFocusAfterRender={true}
        shouldCloseOnOverlayClick={true}
        shouldCloseOnEsc={true}
        shouldReturnFocusAfterClose={true}
        preventScroll={true}
      >
        <div style={{ display: 'flex', flexDirection: 'column', width: '97%', justifyContent: 'flex-start', alignItems: 'center', alignContent: 'center', marginTop: 30 }}>

          <IoIosCloseCircle onClick={() => {
            setAdd_feed(false);
          }} style={{ cursor: 'pointer', position: 'absolute', top: 15, right: 15 }} color='white' size={40} />


          <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', alignSelf: 'center' }}><text style={{ textAlign: 'center', color: 'white', fontWeight: '600', fontSize: 24, fontFamily: "Open Sans", }}>Feedback</text></div>

          <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', alignSelf: 'center', width: 480, marginTop: 50 }}><text style={{ textAlign: 'center', color: '#ECFEFD', fontWeight: '600', fontSize: 18, fontFamily: "Open Sans", }}>Tell us about your suggestion</text></div>
          <textarea placeholder='Comment here' style={{ marginTop: 10, padding: 5, letterSpacing: '1.05px', borderRadius: '6px', width: 470, backgroundColor: '#ECFEFD', outline: 'none', height: 130, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: 'black', fontSize: 17, fontFamily: "Open Sans", paddingLeft: 10, verticalAlign: 'text-top' }} type="text" value={name} onChange={(e) => setName(e.target.value)} />
          <div onClick={() => { addFeedback() }} style={{ cursor: 'pointer', display: 'flex', height: 45, width: 480, justifyContent: 'center', alignContent: 'center', alignItems: 'center', alignSelf: 'center', marginTop: 40, backgroundColor: '#F7941D', borderWidth: 1, borderColor: '#26B8AD', borderStyle: 'solid', borderRadius: 10 }}>
            <text style={{ textAlign: 'center', color: '#000000', fontWeight: '700', fontSize: 24, fontFamily: "Open Sans", }}>Submit</text>
          </div>

        </div>
      </ReactModal>

      <wc-toast></wc-toast>

      <text style={{ fontSize: 16, color: 'white', fontWeight: '600', position: 'absolute', bottom: 10, left: 10, letterSpacing: 1.01 }}>Version 1.7</text>

    </div> : <div style={{ backgroundColor: '#080A0C', display: 'flex', flexDirection: 'row', width: width, height: height, position: 'absolute', top: 0, left: 0 }}>

      <div className={drawerClasses} style={{ width: drawerW }}>

        <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: "#080A0C", width: drawerW, height: 60, justifyContent: 'center', alignItems: 'center' }}>
          <img
            src={logo}
            alt="Logo"
            style={{ width: 113, marginTop: 1, height: 53, alignSelf: 'center' }}
          />

        </div>


        {/* CONTENT */}
        {items.show_welcome ? <div onClick={() => navigate('/Welcome')} style={{ cursor: 'pointer', marginTop: 10, display: 'flex', justifyContent: 'center', alignContent: 'center', width: drawerW, padding: 10, alignSelf: 'center', alignItems: 'center', height: 30, }}>
          <div style={{ width: drawerW - 22, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 36, alignItems: 'center', justifyContent: 'space-between' }}>
            <text style={mobileDrawerTitleStyle((drawerW - 22) - 46)}>Welcome</text>
            <div style={{ height: 30, width: 20 }} />
          </div>
        </div> : null}

        <div style={{ marginTop: items.show_welcome ? 5 : 20, display: 'flex', justifyContent: 'center', alignContent: 'center', width: drawerW - 30, padding: 10, alignSelf: 'center', alignItems: 'center', height: 30 }}>
          <div style={{ backgroundColor: '#181E25', width: drawerW - 42, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 30, alignItems: 'center', justifyContent: 'space-between' }}>
            <text style={mobileDrawerTitleStyle((drawerW - 32) - 46)}>Devices</text>
            <img src={require('../assets/right.png')} style={{ height: 30, width: 20 }} />
          </div>
        </div>

        {/* CONTENT */}
        <div onClick={() => navigate('/Content')} style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: drawerW, padding: 10, alignSelf: 'center', alignItems: 'center', height: 30, }}>
          <div style={{ width: drawerW - 22, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 36, alignItems: 'center', justifyContent: 'space-between' }}>
            <text style={mobileDrawerTitleStyle((drawerW - 22) - 46)}>Content</text>
            <div style={{ height: 30, width: 20 }} />
          </div>
        </div>


        {/* CALENDAR */}
        <div onClick={() => navigate('/Calendars')} style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: drawerW, padding: 10, alignSelf: 'center', alignItems: 'center', height: 30, }}>
          <div style={{ width: drawerW - 22, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 36, alignItems: 'center', justifyContent: 'space-between' }}>
            <text style={mobileDrawerTitleStyle((drawerW - 22) - 46)}>Calendar</text>
            <div style={{ height: 30, width: 20 }} />
          </div>
        </div>


        <div onClick={() => navigate('/AIGenerator')} style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: drawerW, padding: 10, alignSelf: 'center', alignItems: 'center', height: 30, }}>
          <div style={{ width: drawerW - 22, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 36, alignItems: 'center', justifyContent: 'space-between' }}>
            <text style={mobileDrawerTitleStyle((drawerW - 22) - 46)}>AI Generator</text>
            <div style={{ height: 30, width: 20 }} />
          </div>
        </div>

        {/* SUBSCRIPTION */}
        <div onClick={() => navigate('/Subscription')} style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: drawerW, padding: 10, alignSelf: 'center', alignItems: 'center', height: 30, }}>
          <div style={{ position: 'relative', width: drawerW - 22, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 36, alignItems: 'center', justifyContent: 'space-between' }}>
            <text style={mobileDrawerTitleStyle((drawerW - 22) - 46)}>Subscription</text>
            <div style={{ height: 30, width: 20 }} />
            {items.unlicensed > 0 && <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'absolute', height: 20, width: 20, borderRadius: 12, backgroundColor: 'white', borderWidth: 2, borderStyle: 'solid', borderColor: 'red', top: 5, left: 5 }}>
              <text style={{ color: 'red', fontSize: 13 }}>{items.unlicensed}</text>
            </div>}
            {items.trial > 0 && <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'absolute', height: 20, width: 20, borderRadius: 12, backgroundColor: 'white', borderWidth: 2, borderStyle: 'solid', borderColor: '#F7941D', top: 5, right: 20 }}>
              <text style={{ color: '#F7941D', fontSize: 13 }}>{items.trial}</text>
            </div>}
          </div>
        </div>


        {/* SETTINGS */}
        <div onClick={() => navigate('/Settings')} style={{ cursor: 'pointer', marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: drawerW, padding: 10, alignSelf: 'center', alignItems: 'center', height: 30, }}>
          <div style={{ width: drawerW - 22, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, height: 30, alignItems: 'center', justifyContent: 'space-between' }}>
            <text style={mobileDrawerTitleStyle((drawerW - 22) - 46)}>Settings</text>
            <div style={{ height: 30, width: 20 }} />
          </div>
        </div>


        <div onClick={() => {
          navigate('/')
          localStorage.removeItem('display')
          localStorage.removeItem('devices')
          SetId(null)
        }} style={{ left: ((0.35 * width) - 100) / 2, position: 'absolute', bottom: 10, alignContent: 'center', cursor: 'pointer', alignSelf: 'center', width: 150, height: 36, borderRadius: 6, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', borderWidth: 1, borderStyle: 'solid', borderColor: '#F7941D' }}>
          <text style={{ color: '#F7941D', fontSize: 14, fontWeight: '600', textAlign: 'center' }}>Log out</text>
        </div>

      </div>

      {drawerOpen && <BackDrop closeDrawer={handleBackdropClick} />}


      <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 0, width: width, position: 'absolute', top: 0, height: height, backgroundColor: '#181E25', alignItems: 'flex-end' }}>

        <div style={{ display: 'flex', height: 100, width: width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C' }}>

          <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: (width * 0.94) - 5 }}>
            <div style={{ cursor: 'pointer', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <VscThreeBars size={30} color='white' onClick={handleOpenDrawerButton} />
            </div>
            <div style={{ marginLeft: 6, marginTop: 4 }}>
              <stripe-buy-button
                buy-button-id="buy_btn_1RO0KHGOVgfDdjwd10oaS68C"
                publishable-key="pk_live_51HFkGVGOVgfDdjwdQowSBANlgyEuCLom3Lm7B4iCGtKFLXGfU9ezPScsLZNape1srePuSJ0S29nxgQsQ8X5Y2ZMV00txCVBJMu"
              >
              </stripe-buy-button>
            </div>
          </div>

        </div>



        <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: '#181E25', width: width, height: height - 100 }}>

          <text style={{ marginTop: 8, fontSize: 20, fontWeight: '700', letterSpacing: 1.01, color: 'white', textAlign: 'center' }}>  Devices</text>


          <div style={{ width: 0.94 * width, height: 65, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-around', alignSelf: 'center', marginTop: 20, backgroundColor: '#F7941D', borderRadius: 12 }}>

            <div onClick={() => setAdd_feed(true)} style={{ cursor: 'pointer', display: 'flex', width: 130, height: 46, backgroundColor: '#FFFFFF', borderRadius: 10, justifyContent: 'center', alignItems: 'center', flexDirection: 'row' }}>
              <MdOutlineFeed style={{ fontSize: 22 }} />
              <text style={{ fontWeight: '600', fontSize: 15, color: 'black', marginLeft: 15 }}>Feedback</text>
            </div>

            <div onClick={() => setAdd(true)} style={{ cursor: 'pointer', display: 'flex', width: 130, height: 46, backgroundColor: '#FFFFFF', borderRadius: 10, justifyContent: 'center', alignItems: 'center', flexDirection: 'row' }}>
              {add_icon}
              <text style={{ fontWeight: '600', fontSize: 15, color: 'black', marginLeft: 15 }}>Add Device</text>
            </div>


          </div>




          <div style={{ width: 0.94 * width, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'center', marginTop: 20 }}>


            <div style={{ display: 'flex', height: 51, width: 0.15 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
              <div style={{ display: 'flex', height: 51, width: 0.12 * width, justifyContent: 'flex-start', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>

                <text style={{ color: 'white', fontSize: 14, fontWeight: '600', textAlign: 'center' }}>Name</text>
              </div>
            </div>


            <div style={{ display: 'flex', height: 51, width: 0.11 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
              <div style={{ display: 'flex', height: 51, width: 0.10 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>

                <text style={{ color: 'white', fontSize: 14, fontWeight: '600', textAlign: 'center' }}>ID</text>
              </div>
            </div>


            <div style={{ display: 'flex', height: 51, width: 0.11 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
              <div style={{ display: 'flex', height: 51, width: 0.10 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>

                <text style={{ color: 'white', fontSize: 14, fontWeight: '600', textAlign: 'center' }}>Version</text>
              </div>
            </div>



            <div style={{ display: 'flex', height: 51, width: 0.15 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
              <div style={{ display: 'flex', height: 51, width: 0.13 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>

                <text style={{ color: 'white', fontSize: 14, fontWeight: '600', textAlign: 'center' }}>Last connected</text>
              </div>
            </div>



            <div style={{ display: 'flex', height: 51, width: 0.13 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
              <div style={{ display: 'flex', height: 51, width: 0.10 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>

                <text style={{ color: 'white', fontSize: 14, fontWeight: '600', textAlign: 'center' }}>Last Online</text>
              </div>
            </div>



            <div style={{ display: 'flex', height: 51, width: 0.08 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>
              <div style={{ display: 'flex', height: 51, width: 0.07 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#080A0C', borderRadius: 5 }}>

                <text style={{ color: 'white', fontSize: 14, fontWeight: '600', textAlign: 'center' }}>Delete</text>
              </div>
            </div>
          </div>



          <div style={{ width: 0.94 * width, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', alignSelf: 'center', marginTop: 0, overflowY: 'scroll', maxHeight: 1200, overflowX: 'hidden', }}>
            {devices.map((item, id) => <div style={{ width: 0.94 * width, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'center', marginTop: 10 }}>


              <div style={{ display: 'flex', height: 56, width: 0.15 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                <div style={{ display: 'flex', height: 56, width: 0.12 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>

                  <text style={{ color: 'white', fontSize: 12, fontWeight: '600', textAlign: 'center' }}>{item.name != undefined ? decrypt(item.name) : null}</text>
                </div>
              </div>


              <div style={{ display: 'flex', height: 56, width: 0.11 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                <div style={{ display: 'flex', height: 56, width: 0.10 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>

                  <text style={{ color: 'white', fontSize: 12, fontWeight: '600', textAlign: 'center' }}>{item.device}</text>
                </div>
              </div>


              <div style={{ display: 'flex', height: 56, width: 0.11 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                <div style={{ display: 'flex', height: 56, width: 0.10 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>

                  <text style={{ color: 'white', fontSize: 12, fontWeight: '600', textAlign: 'center' }}>{item.version == undefined ? 'Not Found' : Number(item.version).toFixed(1)}</text>
                </div>
              </div>


              <div style={{ display: 'flex', height: 56, width: 0.15 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>

                <div style={{ display: 'flex', height: 56, width: 0.13 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>

                  <text style={{ color: 'white', fontSize: 12, fontWeight: '600', textAlign: 'left', alignSelf: 'center' }}>{dat(Number(item.last)) + '; ' + mytim(Number(item.last))}</text>
                </div>
              </div>



              <div style={{ cursor: 'pointer', display: 'flex', height: 56, width: 0.13 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                <div style={{ display: 'flex', height: 56, width: 0.10 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                  <div style={{ width: 16, height: 16, borderRadius: 10, backgroundColor: lastActiveColor(item.last) }} />
                  <text style={{ color: 'white', fontSize: 12, fontWeight: '600', textAlign: 'left', alignSelf: 'center', marginLeft: 6 }}>{lastActive(Number(item.last))}</text>

                </div>
              </div>






              <div onClick={() => setDeleteContent(item)} style={{ cursor: 'pointer', display: 'flex', height: 56, width: 0.08 * width, justifyContent: 'center', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>
                <div style={{ display: 'flex', height: 56, width: 0.07 * width, justifyContent: 'flex-start', alignItems: 'center', backgroundColor: '#111417', borderRadius: 5 }}>

                  <text style={{ color: 'white', fontSize: 16, fontWeight: '600', textAlign: 'center' }}>{delete_icon}</text>
                </div>
              </div>


            </div>)}
          </div>



        </div>

      </div>

      {!isMobile && <ReactModal
        style={{ overlay: { backgroundColor: 'transparent', display: 'flex', alignSelf: 'center', justifyContent: 'center', alignContent: 'center', alignItems: 'center', height: height }, content: { display: 'flex', position: 'absolute', top: (height - 600) / 2, left: (width - 500) / 2, display: 'flex', backgroundColor: '#111417', width: 550, alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 400, justifyContent: 'center' } }}
        isOpen={add}
        onRequestClose={() => {
          setAdd(false); setSuccess(false); setId('')
          setId2('')
          setId3('')
          setName('')
        }}
        closeTimeoutMS={100}
        shouldFocusAfterRender={true}
        shouldCloseOnOverlayClick={true}
        shouldCloseOnEsc={true}
        shouldReturnFocusAfterClose={true}
        preventScroll={true}
      >
        <div style={{ display: 'flex', flexDirection: 'column', width: '97%', justifyContent: 'center', alignItems: 'center', alignContent: 'center', backgroundColor: '#111417' }}>
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '85%', alignSelf: 'center' }}>
            <text></text>
            <text style={{ fontWeight: '800', fontSize: 26, color: '#3AB549' }}>{success ? `Added successfully.` : null}</text>
            <IoIosCloseCircle onClick={() => {
              setAdd(false); setSuccess(false); setId('')
              setId2('')
              setId3('')
              setName('')
            }} style={{ cursor: 'pointer', position: 'absolute', top: 15, right: 15 }} color='white' size={40} />
          </div>
          {!success ? <div style={{ display: 'flex', flexDirection: 'column', width: '55%', justifyContent: 'center', alignContent: 'center' }}>
            <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', alignSelf: 'center' }}><text style={{ textAlign: 'center', color: 'white', fontWeight: '600', fontSize: 24, fontFamily: "Open Sans", }}>Add New Device </text></div>
            <text style={{ width: 500, alignSelf: 'center', textAlign: 'left', fontSize: 14, fontWeight: '400', color: 'white', marginTop: 20, fontFamily: "Open Sans", }}>ID Number</text>
            <div style={{ width: 500, alignSelf: 'center', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', display: 'flex' }}>
              <input placeholder='ID' style={{ marginTop: 10, padding: 5, letterSpacing: '1.05px', borderRadius: '6px', width: 150, backgroundColor: '#ECFEFD', outline: 'none', height: 35, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: 'black', fontSize: 20, textAlign: 'center', fontFamily: "Open Sans" }} type="text" value={id} onChange={(e) => setId(e.target.value)} />
              <input ref={ref2} placeholder='ID' style={{ marginTop: 10, padding: 5, letterSpacing: '1.05px', borderRadius: '6px', width: 150, backgroundColor: '#ECFEFD', outline: 'none', height: 35, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: 'black', fontSize: 20, textAlign: 'center', fontFamily: "Open Sans", }} type="text" value={id2} onChange={(e) => setId2(e.target.value)} />
              <input ref={ref3} placeholder='ID' style={{ marginTop: 10, padding: 5, letterSpacing: '1.05px', borderRadius: '6px', width: 150, backgroundColor: '#ECFEFD', outline: 'none', height: 35, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: 'black', fontSize: 20, textAlign: 'center', fontFamily: "Open Sans", }} type="text" value={id3} onChange={(e) => setId3(e.target.value)} />

            </div>
            <text style={{ width: 500, alignSelf: 'center', textAlign: 'left', fontSize: 14, fontWeight: '400', color: 'white', marginTop: 20, fontFamily: "Open Sans", }}>Name</text>
            <input ref={ref1} placeholder='Name' style={{ marginTop: 10, padding: 5, letterSpacing: '1.05px', borderRadius: '6px', width: 480, backgroundColor: '#ECFEFD', outline: 'none', height: 35, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: 'black', fontSize: 17, fontFamily: "Open Sans", paddingLeft: 10 }} type="text" value={name} onChange={(e) => setName(e.target.value)} />


            <div onMouseDown={() => toggleTouched1()} onMouseUp={() => handleMouseUp1()} onClick={() => add_device()} style={{ height: 40, padding: 5, alignSelf: 'center', opacity: touched1 ? 0.3 : 1, transition: 'opacity 300ms ease', borderRadius: 5, outline: 'none', marginTop: 30, width: 485, backgroundColor: '#F7941D', display: 'flex', justifyContent: 'center', cursor: 'pointer', alignItems: 'center', borderWidth: 1, borderColor: '#26B8AD' }}> <text style={{ color: 'black', fontWeight: 'bold', fontSize: 22, fontFamily: "Open Sans", }}>Submit</text> </div>
          </div> : <img src={require('../assets/successfull.png')} style={{ width: 300, alignSelf: 'center', height: 300 }} />}
        </div>
      </ReactModal>}

      {isMobile && add != false &&
        <div style={{ boxShadow: '10px 10px 15px -2px rgba(0, 0, 0, 0.5)', display: 'flex', flexDirection: 'column', width: 330, justifyContent: 'center', alignItems: 'center', alignContent: 'center', marginTop: 20, position: 'absolute', top: 150, left: (width - 330) / 2, backgroundColor: '#111417', alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 400, borderWidth: 2, borderColor: 'white', borderStyle: 'solid' }}>
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '85%', alignSelf: 'center' }}>
            <text></text>
            <text style={{ fontWeight: '800', fontSize: 26, color: '#3AB549' }}>{success ? `Added successfully.` : null}</text>
            <IoIosCloseCircle onClick={() => {
              setAdd(false); setSuccess(false); setId('')
              setId2('')
              setId3('')
              setName('')
            }} style={{ cursor: 'pointer', position: 'absolute', top: 15, right: 15 }} color='white' size={40} />
          </div>
          {!success ? <div style={{ display: 'flex', flexDirection: 'column', width: '55%', justifyContent: 'center', alignContent: 'center' }}>
            <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', alignSelf: 'center' }}><text style={{ textAlign: 'center', color: 'white', fontWeight: '600', fontSize: 24, fontFamily: "Open Sans", }}>Add New Device </text></div>
            <text style={{ width: 320, alignSelf: 'center', textAlign: 'left', fontSize: 14, fontWeight: '400', color: 'white', marginTop: 20, fontFamily: "Open Sans", }}>ID Number</text>
            <div style={{ width: 320, alignSelf: 'center', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', display: 'flex' }}>
              <input placeholder='ID' style={{ marginTop: 10, padding: 5, letterSpacing: '1.05px', borderRadius: '6px', width: 90, backgroundColor: '#ECFEFD', outline: 'none', height: 35, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: 'black', fontSize: 16, textAlign: 'center', fontFamily: "Open Sans" }} type="text" value={id} onChange={(e) => setId(e.target.value)} />
              <input ref={ref2} placeholder='ID' style={{ marginTop: 10, padding: 5, letterSpacing: '1.05px', borderRadius: '6px', width: 90, backgroundColor: '#ECFEFD', outline: 'none', height: 35, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: 'black', fontSize: 16, textAlign: 'center', fontFamily: "Open Sans", }} type="text" value={id2} onChange={(e) => setId2(e.target.value)} />
              <input ref={ref3} placeholder='ID' style={{ marginTop: 10, padding: 5, letterSpacing: '1.05px', borderRadius: '6px', width: 90, backgroundColor: '#ECFEFD', outline: 'none', height: 35, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: 'black', fontSize: 16, textAlign: 'center', fontFamily: "Open Sans", }} type="text" value={id3} onChange={(e) => setId3(e.target.value)} />

            </div>
            <text style={{ width: 320, alignSelf: 'center', textAlign: 'left', fontSize: 14, fontWeight: '400', color: 'white', marginTop: 20, fontFamily: "Open Sans", }}>Name</text>
            <input ref={ref1} placeholder='Name' style={{ marginTop: 10, padding: 5, letterSpacing: '1.05px', borderRadius: '6px', width: 310, backgroundColor: '#ECFEFD', outline: 'none', height: 35, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: 'black', fontSize: 17, fontFamily: "Open Sans", paddingLeft: 10 }} type="text" value={name} onChange={(e) => setName(e.target.value)} />


            <div onMouseDown={() => toggleTouched1()} onMouseUp={() => handleMouseUp1()} onClick={() => add_device()} style={{ height: 40, padding: 5, alignSelf: 'center', opacity: touched1 ? 0.3 : 1, transition: 'opacity 300ms ease', borderRadius: 5, outline: 'none', marginTop: 30, width: 310, backgroundColor: '#F7941D', display: 'flex', justifyContent: 'center', cursor: 'pointer', alignItems: 'center', borderWidth: 1, borderColor: '#26B8AD' }}> <text style={{ color: 'black', fontWeight: 'bold', fontSize: 22, fontFamily: "Open Sans", }}>Submit</text> </div>
          </div> : <img src={require('../assets/successfull.png')} style={{ width: 300, alignSelf: 'center', height: 300 }} />}
        </div>
      }



      {(delete_content != false && !isMobile) ? <ReactModal
        style={{ overlay: { backgroundColor: 'transparent', display: 'flex', alignSelf: 'center', justifyContent: 'center', alignContent: 'center', alignItems: 'center', height: height }, content: { display: 'flex', position: 'absolute', top: (height - 530) / 2, left: (width - 500) / 2, display: 'flex', backgroundColor: '#111417', width: 500, alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 260, justifyContent: 'center' } }}
        isOpen={delete_content}
        onRequestClose={() => { setDeleteContent(false) }}
        closeTimeoutMS={100}
        shouldFocusAfterRender={true}
        shouldCloseOnOverlayClick={true}
        shouldCloseOnEsc={true}
        shouldReturnFocusAfterClose={true}
        preventScroll={true}
      >
        <div style={{ display: 'flex', flexDirection: 'column', width: '97%', justifyContent: 'center', alignItems: 'center', alignContent: 'center', backgroundColor: '#111417' }}>

          <IoIosCloseCircle onClick={() => setDeleteContent(false)} style={{ cursor: 'pointer', position: 'absolute', top: 15, right: 15 }} color='white' size={40} />

          <div style={{ display: 'flex', flexDirection: 'column', width: '77%', justifyContent: 'center', alignContent: 'center', marginTop: 0 }}>
            <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', alignSelf: 'center', cursor: 'pointer' }}><text style={{ textAlign: 'center', color: 'white', fontWeight: '600', fontSize: 20 }}>{`Are you sure to delete ${decrypt(delete_content.name)} device ?`}</text></div>

            <div style={{ display: 'flex', alignSelf: 'center', flexDirection: 'row', alignItems: 'center', width: 400, justifyContent: 'space-around', marginTop: 40, cursor: 'pointer' }}>
              <div onMouseDown={() => toggleTouched1()} onMouseUp={() => handleMouseUp1()} onClick={() => delet_content()} style={{ height: 40, padding: 5, alignSelf: 'center', opacity: touched1 ? 0.3 : 1, transition: 'opacity 300ms ease', borderRadius: '5px', outline: 'none', width: 130, backgroundColor: '#3AB549', display: 'flex', justifyContent: 'center', cursor: 'pointer', alignItems: 'center' }}> <text style={{ color: 'black', fontWeight: 'bold', fontSize: 17 }}>Yes</text> </div>
              <div onClick={() => setDeleteContent(false)} style={{ height: 40, width: 130, backgroundColor: 'red', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: 5, padding: 5 }}>
                <text style={{ fontWeight: '600', fontSize: 15, color: 'white' }}>No</text>
              </div>
            </div>
          </div>
        </div>
      </ReactModal> : null}

      {(delete_content != false && isMobile) ?
        <div style={{ boxShadow: '10px 10px 15px -2px rgba(0, 0, 0, 0.5)', display: 'flex', flexDirection: 'column', width: 300, justifyContent: 'center', alignItems: 'center', alignContent: 'center', marginTop: 20, position: 'absolute', top: 150, left: (width - 300) / 2, backgroundColor: '#111417', alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 300, borderWidth: 2, borderColor: 'white', borderStyle: 'solid' }}>

          <IoIosCloseCircle onClick={() => setDeleteContent(false)} style={{ cursor: 'pointer', position: 'absolute', top: 15, right: 15 }} color='white' size={40} />

          <div style={{ display: 'flex', flexDirection: 'column', width: '75%', justifyContent: 'center', alignContent: 'center', marginTop: 0 }}>
            <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', alignSelf: 'center', cursor: 'pointer' }}><text style={{ textAlign: 'center', color: 'white', fontWeight: '600', fontSize: 20 }}>{`Are you sure to delete ${decrypt(delete_content.name)} device ?`}</text></div>

            <div style={{ display: 'flex', alignSelf: 'center', flexDirection: 'row', alignItems: 'center', width: 280, justifyContent: 'space-around', marginTop: 40, cursor: 'pointer' }}>
              <div onMouseDown={() => toggleTouched1()} onMouseUp={() => handleMouseUp1()} onClick={() => delet_content()} style={{ height: 40, padding: 5, alignSelf: 'center', opacity: touched1 ? 0.3 : 1, transition: 'opacity 300ms ease', borderRadius: '5px', outline: 'none', width: 110, backgroundColor: '#3AB549', display: 'flex', justifyContent: 'center', cursor: 'pointer', alignItems: 'center' }}> <text style={{ color: 'black', fontWeight: 'bold', fontSize: 17 }}>Yes</text> </div>
              <div onClick={() => setDeleteContent(false)} style={{ height: 40, width: 110, backgroundColor: 'red', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: 5, padding: 5 }}>
                <text style={{ fontWeight: '600', fontSize: 15, color: 'white' }}>No</text>
              </div>
            </div>
          </div>
        </div> : null}



      {!isMobile && <ReactModal
        style={{ overlay: { backgroundColor: 'transparent', display: 'flex', alignSelf: 'center', justifyContent: 'center', alignContent: 'center', alignItems: 'center', height: height }, content: { display: 'flex', position: 'absolute', top: (height - 600) / 2, left: (width - 550) / 2, display: 'flex', backgroundColor: '#111417', width: 550, alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 400, justifyContent: 'flex-start' } }}
        isOpen={add_feed}
        onRequestClose={() => {
          setAdd_feed(false);
        }}
        closeTimeoutMS={100}
        shouldFocusAfterRender={true}
        shouldCloseOnOverlayClick={true}
        shouldCloseOnEsc={true}
        shouldReturnFocusAfterClose={true}
        preventScroll={true}
      >
        <div style={{ display: 'flex', flexDirection: 'column', width: '90%', justifyContent: 'flex-start', alignItems: 'center', alignContent: 'center', marginTop: 30 }}>

          <IoIosCloseCircle onClick={() => {
            setAdd_feed(false);
          }} style={{ cursor: 'pointer', position: 'absolute', top: 15, right: 15 }} color='white' size={30} />


          <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', alignSelf: 'center' }}><text style={{ textAlign: 'center', color: 'white', fontWeight: '600', fontSize: 24, fontFamily: "Open Sans", }}>Feedback</text></div>

          <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', alignSelf: 'center', width: 480, marginTop: 50 }}><text style={{ textAlign: 'center', color: '#ECFEFD', fontWeight: '600', fontSize: 18, fontFamily: "Open Sans", }}>Tell us about your suggestion</text></div>
          <textarea placeholder='Comment here' style={{ marginTop: 10, padding: 5, letterSpacing: '1.05px', borderRadius: '6px', width: 470, backgroundColor: '#ECFEFD', outline: 'none', height: 130, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: 'black', fontSize: 17, fontFamily: "Open Sans", paddingLeft: 10, verticalAlign: 'text-top' }} type="text" value={name} onChange={(e) => setName(e.target.value)} />
          <div onClick={() => { addFeedback() }} style={{ cursor: 'pointer', display: 'flex', height: 45, width: 480, justifyContent: 'center', alignContent: 'center', alignItems: 'center', alignSelf: 'center', marginTop: 40, backgroundColor: '#F7941D', borderWidth: 1, borderColor: '#26B8AD', borderStyle: 'solid', borderRadius: 10 }}>
            <text style={{ textAlign: 'center', color: '#000000', fontWeight: '700', fontSize: 24, fontFamily: "Open Sans", }}>Submit</text>
          </div>

        </div>
      </ReactModal>}


      {isMobile && add_feed &&
        <div style={{ boxShadow: '10px 10px 15px -2px rgba(0, 0, 0, 0.5)', display: 'flex', flexDirection: 'column', width: 350, justifyContent: 'center', alignItems: 'center', alignContent: 'center', marginTop: 20, position: 'absolute', top: 150, left: (width - 350) / 2, backgroundColor: '#111417', alignSelf: 'center', alignItems: 'center', flexDirection: 'column', borderRadius: 8, height: 400, borderWidth: 2, borderColor: 'white', borderStyle: 'solid' }}>

          <IoIosCloseCircle onClick={() => {
            setAdd_feed(false);
          }} style={{ cursor: 'pointer', position: 'absolute', top: 15, right: 15 }} color='white' size={30} />


          <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', alignSelf: 'center' }}><text style={{ textAlign: 'center', color: 'white', fontWeight: '600', fontSize: 24, fontFamily: "Open Sans", }}>Feedback</text></div>

          <div style={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center', alignSelf: 'center', width: 280, marginTop: 50 }}><text style={{ textAlign: 'center', color: '#ECFEFD', fontWeight: '600', fontSize: 18, fontFamily: "Open Sans", }}>Tell us about your suggestion</text></div>
          <textarea placeholder='Comment here' style={{ marginTop: 10, padding: 5, letterSpacing: '1.05px', borderRadius: '6px', width: 270, backgroundColor: '#ECFEFD', outline: 'none', height: 130, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: 'black', fontSize: 17, fontFamily: "Open Sans", paddingLeft: 10, verticalAlign: 'text-top' }} type="text" value={name} onChange={(e) => setName(e.target.value)} />
          <div onClick={() => { addFeedback() }} style={{ cursor: 'pointer', display: 'flex', height: 45, width: 280, justifyContent: 'center', alignContent: 'center', alignItems: 'center', alignSelf: 'center', marginTop: 40, backgroundColor: '#F7941D', borderWidth: 1, borderColor: '#26B8AD', borderStyle: 'solid', borderRadius: 10 }}>
            <text style={{ textAlign: 'center', color: '#000000', fontWeight: '700', fontSize: 24, fontFamily: "Open Sans", }}>Submit</text>
          </div>

        </div>
      }


      <wc-toast></wc-toast>

      <text style={{ fontSize: 16, color: 'white', fontWeight: '600', position: 'absolute', bottom: 10, left: 10, letterSpacing: 1.01 }}>Version 1.7</text>

    </div>
  );
}


const mapStateToProps = state => {
  //  console.log(state)
  return {
    items: state._todoProduct
  }
}

export default connect(mapStateToProps, { SetId, SetDevice })(Devices)

/*   
 <div style={{ marginLeft: 6, marginTop: 4 }}>
              <stripe-buy-button
                buy-button-id="buy_btn_1RO0KHGOVgfDdjwd10oaS68C"
                publishable-key="pk_live_51HFkGVGOVgfDdjwdQowSBANlgyEuCLom3Lm7B4iCGtKFLXGfU9ezPScsLZNape1srePuSJ0S29nxgQsQ8X5Y2ZMV00txCVBJMu"
              >
              </stripe-buy-button>
            </div>
    <div style={{ marginLeft: 6, marginTop: 4 }}>
              <stripe-buy-button
                buy-button-id="buy_btn_1RO0KHGOVgfDdjwd10oaS68C"
                publishable-key="pk_live_51HFkGVGOVgfDdjwdQowSBANlgyEuCLom3Lm7B4iCGtKFLXGfU9ezPScsLZNape1srePuSJ0S29nxgQsQ8X5Y2ZMV00txCVBJMu"
              >
              </stripe-buy-button>
            </div>
*/